import React from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function StatsCard({ title, value, icon, color }) {
  return (
    <Card className="mb-4 shadow-sm" style={{ borderLeft: `5px solid ${color}` }}>
      <Card.Body>
        <Row className="align-items-center">
          <Col xs={3} className="text-center">
            {/* Render the icon with the specific color and large size */}
            <div style={{ color: color, fontSize: '2.5rem' }}>
              {icon}
            </div>
          </Col>
          <Col xs={9}>
            <div className="text-muted text-uppercase small" style={{ fontSize: '0.85rem', fontWeight: '600' }}>
              {title}
            </div>
            <div className="h3 mb-0 font-weight-bold text-gray-800">
              {value}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}